import { useState, useEffect, useCallback, } from 'react'
import { useTranslation } from 'react-i18next'
import { BaseMenu, BreadCrumb, CustomTable, SnackSimple } from '../../../../components'
import { Roles, Status, Types } from '../../../../utils/enums'
import { Item, ObjectGeneric, onChange, onChangeEvent, Table } from '../../../../utils/types/generals'
import { initialData, initialFilterValues, initialTable, stepsArray, stepsArrayEdit, inputModel, useMenu, filesValidate, menuItems, resendReportForm, resendReportFormEmails } from './initialState'
import { disabled, errorsToStores, filterRow, getDataByFrequency, getList, getQuestionnarie, getStores, handleErrors, listOfEErrors, submit } from './methods'
import { useStyles } from './style'
import { useContextState } from '../../../../hooks/theme'
import { httpFetch } from '../../../../utils/crud'
import { Box, Button, Checkbox, IconButton, Paper, SxProps, Tooltip, Typography } from '@mui/material'
import { icons } from '../../../../utils/icons'
import { ScheduleService } from '../../../../service/schedule'
import SimpleModal from '../../../../components/modal/simpleModal'
import BaseModal from '../../../../components/modal/baseModal'
import { format } from 'date-fns'
import { Constants } from '../../../../utils/constants'
import { DinamicForm } from '../../../../components/dinamicForm'
import Loader from '../../../../components/loader'
import SimpleFile from '../../../../components/dinamicForm/simpleFile'
import { ItemMenu } from '../../../../components/baseMenu'
import { FiltersDrawer } from '../../../../components/filtersDrawer'
import { FileDownload } from '@mui/icons-material'
import { ErrorsCode, TypeDeleteSchedule } from './enums/enums'
import { ModelDownloadButtons } from '../../../../components/donwloadFiles/model'
import { returnQuery, returnQueryWithPagination } from '../../../../utils/methods/returnQuery'
import { getStatus } from '../../../../hooks/status'
import StatusComponent from '../../../../components/status'
import { handleAllErrors } from '../../../../utils/methods/handleErrors'
import { formData, menuList } from './constants/filter'
import { canAccess } from '../../../../utils/validate/canaccess'
import { LoadingButton } from '@mui/lab'
import { isEmailSeparateToCome } from '../../../../utils/validate/validate'
import { actionPlanFetch, scheduleServiceFetch, storeServices, userGroupServiceFetch } from '../../../../utils/constants/callService'
import { AssociatedAgents, PropsAssign } from '../form/components/steps/assignDate/porps'
import { DetailModal } from './components'
import dayjs from 'dayjs'
import { getUserRole } from '../../../../service/auth'
import { DetailState, ListOfStoresWithUsers, OptionMenu, ResendReportState, SubmitResendReport, UserAddOrUndefined } from './types'
import { validateIfTheArraysNumberAreEqueals } from '../../../../utils/methods/validateArrays'
import { StepsRef } from '../form/components/steps/interface'
import { StoreListR } from '../../../../service/stores/response'
import { AgentSteps } from '../form/components/steps'
import { useRefs } from '../../../../hooks/useReactHookModified'
import { resendReportTypes } from './constants/typeResendReport'
import { useNavigate } from 'react-router-dom'
import { getLocalStorage } from '../../../../utils/crud/crypt'
import { useScheduleContext } from '../../context'
import { formatGenerateReportResponse } from '../detail/methods/formatResponse'
import { useTimeOut } from '../../../../hooks/timeOut'
import { FrequencyEnumTable, ScheduleEnumType } from '../form/components/steps/configCalendar/enums'
import { HeaderRowCheckBox } from './components/headerRowCheckBox'
import { HeaderSimple } from '../../../reportFolio/pages/dashboard/pages/main/components'
import { BodyUnit } from './components/unity'
import { LinearProgressDownload } from '../../../logbook/pages/main/components/shared/actionsTabs/linearProgressDownload'
import FilterSelect from '../../../../components/dinamicForm/filterSelect'


const Calendar = () => {
  const { executeFunction } = useTimeOut()
  const navigate = useNavigate()
  const state = getLocalStorage()
  const { t } = useTranslation()
  const menu = useMenu({ t })
  const { colors } = useContextState()
  const ref = useRefs<StepsRef>()
  const [alreadyLoad, setAlreadyLoad] = useState(false)
  const [loadingTable, setLoadingTable] = useState(false)
  const [data, setData] = useState<ObjectGeneric>({
    from: Date.now() + 60000,
    to: null,
    frequency: null,
    title: null,
    notified: false,
    send: false,
  })
  const userLocale: { role: Roles, fullName: string, curp: string, picture: string, id: number, roleName: string } = getLocalStorage()
  const isPartner = [Roles.PARTNER].includes(userLocale.role)
  const [selected, setSelected] = useState<{ stores: number[]; questionnaire: number[] }>({ stores: [], questionnaire: [] })
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingConfirm, setIsLoadingConfirm] = useState(false)
  const [isLoadingDelete, setIsLoadingDelete] = useState(false)
  const [dataList, setDataList] = useState<ObjectGeneric[]>([])
  const [isSendingAll, setIsSendingAll] = useState(false)
  const [flag, setFlag] = useState(false)
  const [totalPages, setTotalPages] = useState(0)
  const [allErrors, setAllErrors] = useState<ObjectGeneric>({})
  const [dataUpload, setDataUpload] = useState<Blob | undefined>()
  const [loadUpload, setLoadUpload] = useState(false)
  const [table, setTable] = useState<Table>(initialTable)
  const styles = useStyles(colors, !!allErrors?.dataUpload)
  const [tableStores, setTableStores] = useState<Table>(initialTable)
  const [tableQuestionnarie, setTableQuestionnarie] = useState<Table>(initialTable)
  const [openModalCSV, setOpenModalCSV] = useState(false)
  const [steps, setSteps] = useState<number | null>(null)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [userSuccess, setUserSuccess] = useState<any[] | null>(null)
  const [isChecked, setIsChecked] = useState(false)
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [notFolioSelected, setNotFolioSelected] = useState<number[]>([]);
  const [snackbarOpen, setSnackbarOpen] = useState({
    open: false,
    message: '',
    type: Types.SUCCESS,
  })
  const [userGroup, setUserGroup] = useState<Item[]>([])
  const [modalDelete, setModalDelete] = useState<{
    open: boolean
    title: string
    description?: string
    children?: JSX.Element
    removeCancel?: boolean
    confirm: () => void
    id?: number,
    type: TypeDeleteSchedule
  }>({
    open: false,
    title: t('schedule.modal.confirmation'),
    description: t('schedule.modal.areYouSureWantDeleteAllSchedulingForTheSeries'),
    confirm: () => { },
    type: TypeDeleteSchedule.UNIQUE
  })
  const [errorUsersQuestionnaries, setErrorUsersQuestionnaries] = useState<{
    user: string,
    useerId: number,
    questionnaires: string[],
    userCanUseThisQuestionnaires: Item[]
  }[]>([])
  const [errorQuestionnairesDuplicated, setErrorQuestionnairesDuplicated] = useState<{
    user: string,
    useerId: number,
    questionnaires: string[],
  }[]>([])
  const [openPreview, setOpenPreview] = useState(false)
  const [errorMassiveLoad, setErrorMassiveLoad] = useState<any>(null)
  const [detailAssigned, setDetailAssigned] = useState<PropsAssign['detail'] & { questionnairesUrls?: Record<string, any> }>({})
  const [listMatched, setListMatched] = useState<ObjectGeneric[]>([])
  const [items, setItems] = useState<{ stores: Item[]; questionnaire: Item[]; user: Item[] }>({ questionnaire: [], stores: [], user: [] })
  const { scheduleData, filterSchedule, isLoading: downloadLoading, getDetailInform, uuid, typeDownload } = useScheduleContext()
  const { input, getData, disabledInputs } = scheduleData
  const [openSnackbar, setOpenSnackbar] = useState({
    open: false,
    message: '',
    type: Types.SUCCESS as string,
  })
  const [detail, setDetail] = useState<DetailState>({
    id: 0,
    reportUrl: '',
    positionMenu: {},
    anchor: null,
    typeOption: FrequencyEnumTable.FRRE,
    serieId: undefined,
    menu: /* canAccess([Roles.PARTNER]) ? menuItems.filter(item => item.value !== 1)   :  */menuItems,
  })

  const [listOfStoresConsulted, setListOfStoresConsulted] = useState<Array<number>>([])
  const [listOfStoresWithUsers, setListOfStoresWithUsers] = useState<ListOfStoresWithUsers>([])
  const [resendReport, setResendReport] = useState<ResendReportState>({
    title: t('reportFolio.modal.sendReport.titleVisit'),
    open: false,
    close: () => { },
    send: () => { },
    values: {}
  })

  const [disabledModal, setDisabledModal] = useState({
    resendButton: true,
    resendButtonLoading: false,
  })

  const [openModalExit, setOpenModalExit] = useState(false)
  const [openModalError, setOpenModalError] = useState(false)
  const [errorMsg, setErrorMsg] = useState<{ code: string; message: string; title: string }>({ code: '', message: '', title: t('general.atention') })
  const [openModal, setOpenModal] = useState<{
    open: boolean
    title: string
    description: string
    submit?: boolean
    id?: number
    isClose?: boolean
  }>({
    submit: true,
    open: false,
    title: t('schedule.modal.submit.title'),
    description: t('schedule.modal.submit.description'),
  })
  const existId = openModal.id || openModal.id === 0
  const [errorsResend, setErrorsResend] = useState<string[]>([])
  const { counter, errors, filterData, paginationModel, query, filterString, sortTable, handlePagination, onChange, cleanFilter } = filterSchedule
  /* const {
    download,
    openSnackbar: snackbarDownloadModal,
    downloadCSV,
    downloadPDF,
    downloadWORD,
    closeOpenSnakbar,
  } = useDownload({
    docName: t('schedule.filter.title'),
    query: returnQueryWithPagination({
      filter: filterString
        .split('&')
        .filter(item => Boolean(item) && !(item.includes('programmed'))).join('&'), sort: query.sort
    }, formData),
    downloadFuntion: ScheduleService(httpFetch).getRegister,
  }) */

  const optionMenu: OptionMenu = ({ item, type }) => {
    const menu: { [x: string]: () => void } = {
      '1': () => {
        /* setOpenModal((prev) => ({
          ...prev,
          id: detail.id,
        }))
        handleEdit(detail.id) */
        navigate(`edit/${detail.id}`, {
          state: {
            option: detail.typeOption == FrequencyEnumTable.UNIQUE || detail.typeOption == FrequencyEnumTable.FRRE ? ScheduleEnumType.UNIQUE : ScheduleEnumType.RECURRENT,
            assignedQuestionnaireId: detail.questionarieId
          }
        });
      },
      '2': () => {
        setOpenModal({
          ...openModal,
          title: t('schedule.modal.wantClose'),
          description: t('schedule.modal.descriptionClose'),
          id: detail.id,
          submit: false,
          open: true,
          isClose: true,
        })
      },
      '3': () => {
        if (detail.reportUrl || item?.questionnaireId) {
          window.open(detailAssigned?.questionnairesUrls?.[item?.questionnaireId]?.reportUrl ?? detail.reportUrl)
        } else {
          generateReport({ id: detail.questionarieId?.toString() ?? '' })
        }
      },
      '4': () => {
        const title = t(`reportFolio.modal.sendReport.${item?.questionnaireId ? 'titleQuestionnaire' : 'titleVisit'}`)
        setResendReport(prev => ({
          ...prev,
          title,
          open: true,
          type,
          close: () => {
            setDisabledModal((prev) => ({
              ...prev,
              resendButton: true,
              resendButtonLoading: false,
            }))
            closeResendModal()
          },
          send: ({ data }: { data: ObjectGeneric }) => {
            submitResendReport({ id: detail.id.toString(), data, questionnaireOption: { id: item?.questionnaireId }, type })
          }
        }))
      },
      '5': () => {
        navigate(`detail/${detail.id}`, {
          state: {
            assignedQuestionnaireId: detail.questionarieId
          }
        })
      },
      '6': () => {
        navigate(`edit/${detail.id}`, {
          state: {
            option: ScheduleEnumType.SERIE,
            assignedQuestionnaireId: detail.questionarieId
          }
        });
      },
      '7': () => {
        setModalDelete(prev => ({
          ...prev,
          open: true,
          title: t('schedule.modal.confirmation'),
          description: t('schedule.modal.areYouSureWantDeleteAllSchedulingForTheSeries'),
          id: detail.serieId, //AGREGAR ID DE LA SERIE
          type: TypeDeleteSchedule.SERIE
          //Agregar acá la funcion para eliminar
        }))
      },
      '8': () => {
        setModalDelete(prev => ({
          ...prev,
          open: true,
          title: t('schedule.modal.confirmation'),
          description: t('schedule.modal.deleteScheduleDescription'),
          id: detail.id, //ID DEL AGENDAMIENTO
          type: TypeDeleteSchedule.UNIQUE
          //Agregar acá la funcion para eliminar
        }))
      },
    }

    menu[item?.value]?.()
  }
  const handleCheanFilter = () => {
    disabledInputs({ inputs: ['createYear', 'month', 'from', 'to'], value: false })
    cleanFilter()
  }
  const handleHeaderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedIds([]);
    setNotFolioSelected([]);
    if (event.target.checked) {
      setIsChecked(true)
    } else {
      setIsChecked(false)
    }
  };
  const handleOpenModalDelete = () => {
    if (selectedIds.length === 0 && !isChecked) {
      setSnackbarOpen(prev => ({
        ...prev,
        open: true,
        message: t('schedule.snackbar.selectAtLeastOneSchedule'),
        type: Types.ERROR
      }))
    } else {
      setModalDelete(prev => ({
        ...prev,
        open: true,
        title: t('schedule.modal.confirmation'),
        description: t('schedule.modal.areYouSureWantDeleteAllSchedulingSelected', { count: selectedIds.length }),
        type: TypeDeleteSchedule.MASIVE
        //Agregar acá la funcion para eliminar
      }))
    }
  }
  const closeModalDelete = () => {
    setModalDelete(prev => ({
      ...prev,
      open: false,
    }))
  }
  const closeMenu = () => {
    setDetail((prev) => ({
      ...prev,
      anchor: null,
    }))
  }
  const column: any[] = [
    {
      field: 'checkbox',
      headerName: '',
      label: (
        <Checkbox
          checked={isChecked}
          onChange={handleHeaderChange}
          color="primary"
        />
      ),
      renderCell: (params: any) => {
        const status = params?.row?.status?.value
        const validation = (params.row.createById == state.id && status == Status.TO_BE_STARTED) || state.role == Roles.ADMIN
        return (
          <>

            <HeaderRowCheckBox
              id={params.row.id}
              isChecked={isChecked}
              selectedIds={selectedIds}
              setSelectedIds={setSelectedIds}
              notFolioSelected={notFolioSelected}
              setNotFolioSelected={setNotFolioSelected}
              disabled={!validation}
            />

          </>
        )
      }
    },
    {
      id: 'division',
      label: t('general.tags.division'),
      sortable: true,
      minWidth: 100,
    },
    {
      id: 'agent',
      label: t('general.tags.assignedUser'),
      sortable: true,
      minWidth: 100,
    },
    {
      id: 'unit',
      label: '',
      sortable: true,
      headerCell: {
        '&.header-cell': {
          '& div': {
            width: '150px',
          },
        },
      },
      column: () => <HeaderSimple value={[t('general.tags.idStore'), t('general.tags.zoneClass')]} />,
      renderCell: (params: any) => <BodyUnit {...params} />,
    },
    {
      id: 'questionnaire',
      label: t('general.tags.questionnaire'),
      sortable: true,
      minWidth: 100,
    },
    /* {
      id: 'agent',
      label: t('general.tags.assignedUser'),
      sortable: true,
      minWidth: 100,
    }, */
    {
      id: 'frequencyType',
      label: t('general.tags.frequency'),
      //sortable: true,
      minWidth: 100,
    },
    {
      id: 'scheduleType',
      label: t('general.tags.type'),
      minWidth: 100,
    },
    {
      id: 'available_from',
      label: t('general.tags.available_from'),
      sortable: true,
      minWidth: 100,
    },
    {
      id: 'available_to',
      label: t('general.tags.available_to'),
      sortable: true,
      minWidth: 100,
    },
    {
      id: 'status',
      label: t('general.tags.status'),
      minWidth: 100,
      /* renderCell: (params) => {
        const status = getStatus(params?.current?.value == Status.CLOSE ? Status.CANCEL : params?.current?.value, colors, t,)
        return (
          <StatusComponent color={status.color} msg={status.text} size='small' />
        )
      } */
    },
    {
      id: 'action',
      label: t('general.tags.action'),
      minWidth: 50,
      renderCell: (params: any) => {
        const id = params?.row?.id
        return (
          <Box sx={styles.containerStatus}>
            <Tooltip title={t('ToolTips.seeActions')}>
              <IconButton
                onClick={(e) => {
                  const status = params?.row?.status?.value
                  const type: FrequencyEnumTable = params?.row?.frequencyTypeValue;
                  const validation = !!(params.row.createById !== state.id) && state.role !== Roles.ADMIN

                  let baseMenu = menuList[status as Status] || [];

                  if (state.role !== Roles.ADMIN && status !== Status.TO_BE_STARTED) {
                    baseMenu = baseMenu.filter(value => value !== 7 && value !== 8);
                  }

                  let menu: ItemMenu[] = menuItems
                    .filter(item => baseMenu.includes(item.value))
                    .filter(item => { if (type === FrequencyEnumTable.FRRE || type === FrequencyEnumTable.UNIQUE) { return item.value !== 6 && item.value !== 7; } return true; })
                    .filter(item => { if (validation) { return ![8, 7, 1, 6].includes(item.value) } return true; });
                  setDetail({
                    id,
                    serieId: params.row.serieId,
                    questionarieId: params.row.questionarieId,
                    reportUrl: params?.row?.reportUrl,
                    positionMenu:
                      table?.row?.length < Constants.numberOfRows
                        ? {
                          top: 0,
                          left: '-30px',
                        }
                        : {
                          top: `${e.clientY}px`,
                          left: `${e.clientX - 120}px`,
                        },
                    anchor: e.currentTarget,
                    typeOption: params?.row?.frequencyTypeValue as FrequencyEnumTable,
                    menu: /* canAccess([Roles.PARTNER]) ? menu.filter(item => item.value !== 1) : */ menu,
                  })
                }}
              >
                {icons('moreHoriz')}
              </IconButton>
            </Tooltip>
          </Box>
        )
      },
    },
  ]
  const generateReport = async ({ id }: { id: string }) => {
    const response = await scheduleServiceFetch.getGenerateReport({ id })
    if (!response?.errors) {
      const reportUrl = formatGenerateReportResponse({ response })
      if (reportUrl) {
        setTable(prev => ({
          ...prev,
          row: prev.row.map(row => {
            if (row.id == id) {
              return {
                ...row,
                reportUrl
              }
            }
            return row
          })
        }))
        window.open(reportUrl)
      }
    }
  }

  const getUserGroup = async () => {
    const response = await userGroupServiceFetch.getUserGroupSelect()

    if (!response.errors) {
      setUserGroup(response.map(item => ({
        label: item.name,
        value: item.id,
      })))
    } else {
      setUserGroup([])
    }

  }

  const handleCloseSnackbar = (value: boolean) => setOpenSnackbar({ ...openSnackbar, open: value })

  const crudChange = (e: onChangeEvent): void => {
    const { name, value } = e.target
    let body = { ...data }
    if (name !== 'stores') {
      body = {
        ...data,
        [name]: value,
        ...(name === 'frequency' ? { every: null } : {}),
      } as ObjectGeneric
    } else {
      const valueStores: number[] = body?.[name]?.[value.id] ?? []

      let valueStoreById: number[] = []

      if (!openModal.id) {
        valueStoreById = valueStores?.some((item: number) => item === value.checkId) ? valueStores?.filter((item) => item !== value.checkId) : [...valueStores, value.checkId]
      } else {
        valueStoreById = [value.checkId]
      }
      body = {
        ...body,
        [name]: {
          ...body[name],
          [value.id]: valueStoreById,
        },
      }
    }

    if (!body.frequency) {
      body = {
        ...body,
        every: null,
      }
    }

    setData(() => body)
    setAllErrors(handleErrors(body, t))
  }
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    handleCreate()
  }
  const handleSubmit = () => {
    setData(() => ({ ...data, send: true }))
    setOpenModal((prev) => ({
      ...prev,
      submit: true,
      open: true,
      title: t(`schedule.modal.submit.${openModal.id ? 'titleUpdate' : 'title'}`),
      description: t(`schedule.modal.submit.${openModal.id ? 'descriptionUpdate' : 'description'}`),
    }))
  }

  const formatDataToEndoint = (dataList: ObjectGeneric[]) => {
    const body: {
      title?: string
      description?: string
      questionnaires: { questionnaireId: number }[]
      userAssignId: number[]
      storeId: number
      openScheduled: boolean
      dateStart?: string
      dateEnd?: string
      timeStart?: string | null
      timeEnd?: string | null
      notified?: number
      notifiedAdmin?: number
      duration?: number | null
      days?: number[] | null
      frequency?: string
      every?: string | null
    }[] = []

    for (const match of dataList) {
      const data = match.id?.split('-')
      const { dateEnd, dateStart, days, duration, every, frequency, timeEnd, timeStart } = getDataByFrequency(match);

      body.push({
        openScheduled: !!match.openQuestionnaire,
        questionnaires: [{ questionnaireId: Number(data?.[2]) }],
        storeId: Number(data?.[0]),
        userAssignId: [Number(data?.[1])],
        title: match.title ?? '',
        description: match.description ?? '',
        notified: match.notified ? 1 : 0,
        notifiedAdmin: match.notifiedAdmin ? 1 : 0,
        ...!match.openQuestionnaire && {
          dateStart: dateStart,
          dateEnd: dateEnd,
          every: every,
          timeStart: timeStart,
          timeEnd: timeEnd,
          frequency: frequency,
          duration: duration,
          days: days
        }
      })
    }

    return body
  }

  const handleConfirm = async () => {
    setIsLoadingConfirm(true)
    const body = formatDataToEndoint(dataList)
    formatDataToEndoint(body)
    const response = await submit({ data: body, t, id: openModal.id })

    if (!response?.response?.errors) {
      const code = response?.response?.code
      if (code !== ErrorsCode.AllUsersHavePermissions) {
        setOpenModalError(true)
      }

      const data = response?.response?.data
      const message = t(`general.messages.errors.visits.create.${code}`)
      if (code === ErrorsCode.SomeOneUserNotHavePermissions) {
        setErrorMsg((prev) => ({ ...prev, code, message }))
        const { questionnairesduplicates, usersByQuestionnaires, userSuccess } = listOfEErrors({ data: data?.dataNotCreated, selected, tableQuestionnarie, detailAssigned })
        setErrorUsersQuestionnaries(usersByQuestionnaires)
        setErrorQuestionnairesDuplicated(questionnairesduplicates)
        setUserSuccess(userSuccess)
        let uncheckUsers: Record<string, (string | number)[]> = {}
        let newStoreList = selected.stores
        const listOfStoresToRemove: Array<number> = []
        let newDetailAssignedList = detailAssigned?.stores?.list
        for (const store of selected.stores) {
          const selectedStore = body?.stores?.[store]
          if (selectedStore) {
            const listWithErrors = selectedStore.filter((storeData: string) => !userSuccess.some(success => success.userId == storeData))

            if (!!listWithErrors?.length) {
              uncheckUsers = {
                ...uncheckUsers,
                [store]: listWithErrors
              }
            } else {
              listOfStoresToRemove.push(store)
              newStoreList = newStoreList?.filter((storeSelect) => storeSelect != store)
              newDetailAssignedList = newDetailAssignedList?.filter(list => list.id != store)
            }
          }
        }
        const errorList = errorsToStores({ data: data?.dataNotCreated })

        if (ref.refsByKey['step']?.setData) {
          ref.refsByKey['step']?.setData({ errors: errorList.body, success: [] })
        }
        setSelected(prev => ({ ...prev, stores: newStoreList }))
        setData(prev => ({ ...prev, stores: { ...uncheckUsers } }))
      }
      if (code === ErrorsCode.AllUsersHavePermissions) {
        setOpenSnackbar(response.snackbarBody)
        if (isSendingAll || !!openModal.id) {
          getDetail({ reloadItems: true })
          cleanFilter()
          restartLists()
          setUserSuccess(null)
        }
        if (ref.refsByKey['step']?.setData) {
          ref.refsByKey['step']?.setData({ errors: {}, success: dataList.map(list => list.id) })
        }
      }

      if (code) {
        setErrorMsg((prev) => ({ ...prev, code, message }))
      }
    } else {
      const { code } = response?.response?.errors?.[0]

      if ((code as string) === ErrorsCode.AllTheUserNotHavePermissions) {
        const { data } = response?.response?.errors?.[0]
        const message = t(`general.messages.errors.visits.create.${code}`)
        setErrorMsg((prev: any) => ({ ...prev, code, message }))
        setOpenModalError(true)
        const errorList = errorsToStores({ data: data?.dataNotCreated })

        if (ref.refsByKey['step']?.setData) {
          ref.refsByKey['step']?.setData({ errors: errorList.body, success: [] })
        }
      } else {
        setOpenSnackbar(response.snackbarBody)
        setData(() => ({ ...data, send: false }))
        let body = { ...data }
        setAllErrors(handleErrors(body, t))
      }
    }

    setIsLoadingConfirm(false)
    setOpenModal((prev) => ({
      ...openModal,
      submit: false,
      open: false,
      isClose: false,
    }))
  }

  const handleCloseModal = (removedId?: boolean) => {
    if (!removedId) {
      setData(() => ({ ...data, send: false }))
      let body = { ...data }
      setAllErrors(handleErrors(body, t))
      setIsLoadingConfirm(false)
    }
    setOpenModal({
      ...openModal,
      ...(!!removedId || !!openModal.isClose ? { id: undefined } : {}),
      submit: false,
      open: false,
      isClose: false,
    })
  }

  const handleEdit = (id: number) => {
    getItem(id)
    setOpenModal((prev) => ({
      ...prev,
      submit: false,
      open: false,
    }))
  }

  const restartLists = () => {
    setErrorQuestionnairesDuplicated([])
    setErrorUsersQuestionnaries([])
    setListOfStoresConsulted([])
    setListOfStoresWithUsers([])
  }
  const goBackToList = () => {
    setOpenModalExit(true)
    setUserSuccess(null)
    restartLists()
  }
  const handleCloseScheduled = async () => {
    if (openModal.id) {
      setIsLoadingConfirm(true)
      const response = await ScheduleService(httpFetch).closeSchedule(openModal.id)

      if (!response.errors) {
        setOpenSnackbar(prev => ({
          ...prev,
          open: true,
          message: t('schedule.closeQuestionnaire.success')
        }))

        setOpenModal((prev) => ({
          ...openModal,
          submit: false,
          open: false,
        }))
        getDetail({
          query: returnQuery(query, formData),
          goBack: true,
        })
      } else {
        setOpenSnackbar(prev => ({
          ...prev,
          open: true,
          message: t('schedule.closeQuestionnaire.error')
        }))
      }
      setIsLoadingConfirm(false)
    }
  }

  const getItem = (e: any, notCreate?: boolean) => {
    if (!notCreate) {
      setIsLoading(true)
      handleCreate()
    }
    ScheduleService(httpFetch)
      .getScheduleById(e)
      .then((response) => {
        let body = {
          ...data,
          agentAssigned: response.userAssignId,
          supervisor: response.userManage ? response.userManage : null,
          agent: response.userAssign ? `${response.userAssign.firstName} ${response.userAssign.lastName}` : null,
          from: new Date(response.dateStart).getTime(),
          to: new Date(response.dateEnd).getTime(),
          title: response.title,
          notified: response.notified === 1,
          description: response.description,
          openQuestionnaire: response?.assignedQuestionnaires?.[0]?.openScheduled == 1
        }
        let questionnairesUrls: Record<string, any> = {}

        setSelected({
          stores: response.store?.id ? [response.store?.id] : [],
          questionnaire: response.assignedQuestionnaires ? [...new Set(response.assignedQuestionnaires.map((item) => {
            const questionnaire = item?.questionnaireMainData || item?.questionnaire

            return questionnaire?.id
          }))] : [],
        })

        if (!notCreate) {
          if (ref.refsByKey['step']?.defaulDataList) {
            ref.refsByKey['step']?.defaulDataList({
              data: [{
                id: `${response.store?.id}-${response?.userAssignId}-${response.assignedQuestionnaires?.[0]?.questionnaireMainId}`,
                from: null,
                to: null,
                title: response.title,
                notified: response.notified === 1,
                description: response.description,
                openQuestionnaire: response?.assignedQuestionnaires?.[0]?.openScheduled == 1,
                selectedDays: []
              }]
            })
          }
        }
        setDetailAssigned({
          stores: {
            title: t('schedule.assigned.selectedStores'),
            list: [
              {
                title: {
                  element: <Typography sx={[styles.titleList, styles.detailTitle]}>{response.store?.name ?? 'N/A'} - {response.store?.keyCode}</Typography>,
                  size: {
                    xl: 12,
                    lg: 12,
                    md: 12,
                    sm: 12,
                    xs: 12,
                  },
                },
                phone: {
                  element: <Typography sx={[styles.titleList]}>{`Telf: ${response.store?.phone ?? 'N/A'}`}</Typography>,
                  size: {
                    xl: 4,
                    lg: 4,
                    md: 4,
                    sm: 4,
                    xs: 4,
                  },
                },
                email: {
                  element: <Typography sx={[styles.titleList]}>{t('general.tags.email')}:{` ${response.store?.email ?? 'N/A'}`}</Typography>,
                  size: {
                    xl: 8,
                    lg: 8,
                    md: 8,
                    sm: 8,
                    xs: 8,
                  },
                },
                address: {
                  element: <Typography sx={[styles.titleList]}>{t('general.tags.address')}:{` ${response.store?.address ?? 'N/A'}`}</Typography>,
                  size: {
                    xl: 12,
                    lg: 12,
                    md: 12,
                    sm: 12,
                    xs: 12,
                  },
                },
                id: response.store?.id,
                associatedAgents: [],
              },
            ],
          },
          questionnaire: {
            title: t('schedule.assigned.selectedQuestionnaires'),
            list:
              response.assignedQuestionnaires?.map((item) => {
                const percentage: string[] | undefined = item?.resultQuestionnaire?.split?.('/')
                const resultQuestionnaire = percentage ? (parseInt(percentage?.[0]) / parseInt(percentage?.[1])) * 100 : null
                const status = getStatus(item?.statusId, colors, t)
                const startDate = item?.dateStart ? format(new Date(item?.dateStart), Constants.dateFormatGeneral) : ''
                const endDate = item?.dateEnd ? format(new Date(item?.dateEnd), Constants.dateFormatGeneral) : ''
                const reportStartDate = item?.reportDate ? format(new Date(item?.reportDate), Constants.dateFormatGeneral) : ''
                const lastReportDate = item?.lastDateReportFile ? format(new Date(item?.lastDateReportFile), Constants.dateFormatGeneral) : ''
                const resultReportDate = item?.reportResultDate ? format(new Date(item?.reportResultDate), Constants.dateFormatGeneral) : ''
                const questionnaireMain = item?.questionnaireMainData || item?.questionnaire
                const isScheduleOpen = Boolean(Number(item?.openScheduled ?? 0))
                questionnairesUrls = {
                  ...questionnairesUrls,
                  [item?.id ?? ""]: {
                    reportUrl: item.reportUrl,
                    latReportUrl: item.lastReportFile,
                    reportResultUrl: item?.reportResultUrl ?? '',
                  }
                }
                return {
                  title: questionnaireMain?.name || 'N/A',
                  status: {
                    element: <StatusComponent msg={status.text} color={status.color} />,
                  },
                  ask: questionnaireMain?.sumQuestions ? `${t('general.answeredQuestions')}: ${item.amountQuestionsAnswered}/${questionnaireMain?.sumQuestions}` : 'N/A',
                  section: questionnaireMain?.sectionCount,
                  amountSection: item.amountSectionsCompleted,
                  amountQuestionAnswers: item.amountQuestionsAnswered,
                  scheduleType: t(`schedule.scheduleTypes.${isScheduleOpen ? 'free' : 'programmed'}`),
                  percentage: resultQuestionnaire || resultQuestionnaire == 0 ? `${resultQuestionnaire.toFixed(2)}%` : 'Sin resultado',
                  date: {
                    element: (
                      <Box sx={styles.dateContainer}>
                        <Typography sx={styles.text2}>{`${t('general.startDate')}: ${startDate}`}</Typography>
                        <Typography sx={styles.text2}>{`${t('general.endDate2')}: ${endDate}`}</Typography>
                      </Box>
                    ),
                  },
                  amountQuestion: questionnaireMain?.sumQuestions,
                  from: startDate,
                  to: endDate,
                  reportStartDate,
                  lastReportDate,
                  resultReportDate,
                  id: item?.id,
                }
              }) ?? [],
          },
          questionnairesUrls
        } as any)

        setData(body)
        setAllErrors(handleErrors(body, t))
      })
      .catch((data) => {
        console.error(`error get Schedule: ${data}`)
      })
      .finally(() => {
        if (notCreate) {
          setOpenPreview(true)
        }
      })
  }

  const getDetail = useCallback(
    async (data?: { query?: string; goBack?: boolean; reloadItems?: boolean }) => {
      setOpenModalError(false)
      if (data?.goBack) {
        setLoadingTable(true)
      }
      setSteps(null)

      const responseStores = await getList(colors, t, data, alreadyLoad)

      if (!alreadyLoad || !!data?.reloadItems) {
        setAlreadyLoad(true)
      }

      setTotalPages(responseStores?.totalPages || 0)
      setTable({
        column: [],
        row: responseStores?.row,
      })
      setIsLoading(false)
      setLoadingTable(false)
      if (!data?.goBack) {
        goBack()
      }
      setIsLoading(false)
    },
    // eslint-disable-next-line
    [colors, t, alreadyLoad, query.all]
  )

  const getAllData = useCallback(async () => {
    setFlag(true)
    setIsLoading(true)
    setLoadingTable(true)
    getData()
    getDetail({
      goBack: true,
      query: returnQuery(query, formData).split('&')
        .filter(item => Boolean(item) && !(item.includes('programmed'))).join('&'),
    })
    // setLoadingTable(false)
  }, [getDetail])

  const handleCreate = async (cancelLoading?: boolean) => {
    setAllErrors({
      ...allErrors,
      dataUpload: null,
    })
    setIsLoading(true)
    setSteps(0)
    getStores({ t })
      .then((data: any) => {
        if (!!data?.errors) {
          setSteps(null)
        }
        setTableStores(data)
        if (!cancelLoading) {
          setIsLoading(false)
        }
      })
      .catch(() => {
        setSteps(null)
      })
    setTableQuestionnarie(await getQuestionnarie(t))
  }

  const getUserByStoreIds = async () => {
    setIsLoading(true)
    const storeIds = selected.stores.join()
    const queary = `?stores_ids=${storeIds}`
    let storesWithUser: ListOfStoresWithUsers = []
    if (!validateIfTheArraysNumberAreEqueals(selected.stores, listOfStoresConsulted)) {
      /* const isAgentOrAudit = canAccess([Roles.AUDIT, Roles.AGENT])
      if (!isAgentOrAudit) { */
      const data = await storeServices.getAllStoresWithAgents({ queary })
      const role = getUserRole()

      if (!data.errors) {
        storesWithUser = data
          ?.filter((item) => item?.statusId === Status.ACTIVE)
          ?.map((item) => {
            const users: any[] = [...item?.users ?? []]
            return {
              id: item?.id,
              name: item?.name,
              keyCode: item.keyCode,
              email: item?.email,
              phone: item?.phone,
              address: item?.address,
              storeTimeZone: item?.storeTimeZone,
              associatedAgents:
                users?.map((agentItems) => ({
                  fullName: `${agentItems.firstName} ${agentItems.lastName}`,
                  curp: agentItems.curp,
                  active: true,
                  image: agentItems.picture,
                  id: agentItems.id,
                  role: agentItems.role
                })) ?? [],
            }
          })
      }
      /* } else {
        storesWithUser = tableStores.row?.filter(row => selected.stores.some(store => store == row.id))?.map(store => ({
          id: store?.id,
          name: store?.name,
          keyCode: store.keyCode,
          email: store?.email,
          phone: store?.phone,
          address: store?.address,
          storeTimeZone: store?.storeTimeZone,
          associatedAgents: [{
            fullName: state?.fullName ?? '',
            curp: state?.curp ?? '',
            active: true,
            image: state?.picture ?? '',
            id: state?.id ?? '',
            role: state?.role ?? ''
          }]
        }))
      } */
      setListOfStoresConsulted(selected.stores)
      setListOfStoresWithUsers(storesWithUser)
    }
    setIsLoading(false)
    return { storesWithUser }
  }
  const matchItems = ({ stores, questionnaires }: {
    stores: (StoreListR & {
      associatedAgents: {
        fullName: string;
        curp: string;
        active: true;
        image: string | null;
        id: number;
        role: string;
      }[]
    })[]; questionnaires: ObjectGeneric[]
  }) => {
    const userList: Item[] = []
    const localUser: { role: Roles, fullName: string, curp: string, picture: string, id: number, roleName: string } = getLocalStorage()
    let user: UserAddOrUndefined;

    if ([Roles.SUPERVISOR, Roles.STORE, Roles.GERENT, Roles.SUPPORT, Roles.AUDIT, Roles.AGENT, Roles.PARTNER].includes(localUser.role)) {
      user = {
        fullName: localUser.fullName,
        curp: localUser.curp,
        active: true,
        image: localUser.picture,
        id: localUser.id,
        role: localUser.roleName
      }
    } else {
      user = undefined;
    }

    for (const store of stores) {
      if (store.associatedAgents?.length) {
        for (const user of store.associatedAgents) {
          const existUser = userList.some(userL => userL.value == user.id)
          if (!existUser) {
            userList.push({
              id: user.id.toString(),
              value: user.id,
              label: user.fullName
            })
          }
        }
      }
    }

    if (user) {
      userList.push({
        id: String(user.id),
        value: user.id,
        label: user.fullName
      })
    }

    setItems(() => ({
      stores: stores.map(store => ({ label: `${store.keyCode}-${store.name}` ?? '', id: store.id.toString(), value: store.id })),
      questionnaire: questionnaires.map(questionnaire => ({ label: questionnaire.title ?? '', id: questionnaire.id.toString(), value: questionnaire.id })),
      user: userList
    }))
    const listMatched = stores.flatMap(store =>
      store?.associatedAgents?.flatMap((user) => {
        if (isPartner) {
          return []; // Retornar un array vacío si el rol coincide
        }
        return questionnaires.map(questionnaire => {
          const id = `${store.id}-${user.id}-${questionnaire.id}`
          return ({
            ...user,
            id: id,
            storeName: store.name,
            storeEmail: store.email,
            storePhone: store.phone,
            storeId: store.id,
            storeTimeZone: store.storeTimeZone,
            keyCode: store.keyCode,
            userId: user.id,
            questionnaireId: questionnaire.id,
            questionnaireName: questionnaire.title ?? "",
            ask: questionnaire?.ask ?? ""
          })
        })
      }) || []
    );

    if (user) {
      const additionalUserEntries = stores.flatMap(store =>
        questionnaires.map(questionnaire => ({
          ...user,
          id: `${store.id}-${user.id}-${questionnaire.id}`,
          storeName: store.name,
          storeEmail: store.email,
          storePhone: store.phone,
          storeId: store.id,
          storeTimeZone: store.storeTimeZone,
          keyCode: store.keyCode,
          userId: user.id,
          questionnaireId: questionnaire.id,
          questionnaireName: questionnaire.title ?? "",
          ask: questionnaire?.ask ?? ""
        }))
      );

      listMatched.push(...additionalUserEntries);
    }

    return listMatched
  }

  const handleSteps = async (step: number) => {
    const currentStep = (steps ?? 0) + step
    if (currentStep === 2 || ((!!openModal.id || isPartner) && currentStep === 1)) {
      const { storesWithUser } = await getUserByStoreIds()
      const listOfStore = !!storesWithUser?.length ? storesWithUser : listOfStoresWithUsers
      const listOfaPartner: ListOfStoresWithUsers = [tableStores.row[0]]
      setErrorUsersQuestionnaries([])
      setErrorQuestionnairesDuplicated([])
      setUserSuccess(null)
      const from = dayjs(data?.from)
      const to = dayjs(data?.to)
      if (from.isBefore(dayjs())) {
        setData(prev => ({ ...prev, from: dayjs().valueOf() }))
      }
      if (to.isBefore(from.add(5, 'minute')) || to.isBefore(dayjs())) {
        setData(prev => ({ ...prev, to: null }))
      }
      const listMatched = matchItems({
        stores: !isPartner ? listOfStore : listOfaPartner,
        questionnaires: tableQuestionnarie?.row
          ?.filter((item: any) => selected.questionnaire.includes(item.id))
          ?.map((item: any) => ({
            title: item.quest_name ?? 'N/A',
            ask: item.ask ? `${item.ask} ${t('general.asks')}` : 'N/A',
            id: item.id,
          }))
      })
      setListMatched(listMatched)
    }
    if (currentStep >= 3 || (currentStep > 1 && (openModal.id || isPartner))) {
      handleSubmit()
    } else {
      if (currentStep === 2 || (currentStep === 1 && isPartner)) {
        setData((prev) => ({
          ...prev,
          from: Date.now() + 5000,
          to: null,
        }))
        setAllErrors(() =>
          handleErrors(
            {
              ...data,
              title: null,
              frequency: null,
              every: null,
              from: Date.now() + 5000,
              to: null,
            },
            t
          )
        )
      }
      setSteps((prev) => (prev ?? 0) + step)
    }
  }

  const handleDeleteDetail = (id: number | string, name: string) => {
    setDetailAssigned((prev) => ({
      ...prev,
      [name]: {
        ...detailAssigned[name],
        list: detailAssigned?.[name]?.list?.filter((item: any) => item?.id !== id) ?? [],
      },
    }))
    setSelected((prev) => ({
      ...prev,
      [name]: prev?.[name as 'questionnaire' | 'stores']?.filter((item) => item !== id),
    }))

    delete data.stores[id]

    let body = { ...data, [name]: { ...data.stores } }
    setData(() => body)
  }

  const deleteChekedTrue = (id: number | string, name: string) => {
    let body = { ...data }
    body = { ...body, [name]: { ...body[name], [id]: [] } }
    setData(() => body)
    setAllErrors(handleErrors(body, t))
  }

  const deleteCheckedFalse = (id: number | string, name: string, associatedAgents: AssociatedAgents[]) => {
    let body = { ...data }
    let agents = associatedAgents.map((items) => items.id)

    body = { ...body, [name]: { ...body[name], [id]: agents } }
    setData(() => body)
    setAllErrors(handleErrors(body, t))
  }

  const handleDeleteSchedules = async () => {
    setIsLoadingDelete(true)

    const payload = {
      all: isChecked,
      schedules_ids: isChecked ? [] : selectedIds,
      not_schedules_ids: isChecked ? notFolioSelected : []
    };

    let response;

    if (modalDelete.type == TypeDeleteSchedule.UNIQUE) {
      response = await ScheduleService(httpFetch).deleteScheduleRecurrent(String(modalDelete.id));
    }

    if (modalDelete.type == TypeDeleteSchedule.SERIE) {
      response = await ScheduleService(httpFetch).deleteScheduleSerie(String(modalDelete.id));
    }

    if (modalDelete.type == TypeDeleteSchedule.MASIVE) {
      response = await ScheduleService(httpFetch).deleteScxheduleMasive(payload, isChecked ? returnQuery(query, formData) : undefined);
    }

    if (!response.errors) {
      if (modalDelete.type == TypeDeleteSchedule.UNIQUE) {
        setSnackbarOpen(prev => ({ ...prev, open: true, message: t('schedule.snackbar.delete.success.unique'), type: Types.SUCCESS }))
      }

      if (modalDelete.type == TypeDeleteSchedule.SERIE) {
        setSnackbarOpen(prev => ({ ...prev, open: true, message: t('schedule.snackbar.delete.success.serie'), type: Types.SUCCESS }))
      }

      if (modalDelete.type == TypeDeleteSchedule.MASIVE) {
        setSnackbarOpen(prev => ({ ...prev, open: true, message: t('schedule.snackbar.delete.success.masive', { count: selectedIds.length }), type: Types.SUCCESS }))
      }

      setSelectedIds([]);
      setNotFolioSelected([]);

      getDetail({
        query: returnQuery(query, formData).split('&')
          .filter(item => Boolean(item) && !(item.includes('programmed'))).join('&'),
        goBack: true,
      })

    } else {
      if (modalDelete.type == TypeDeleteSchedule.UNIQUE) {
        setSnackbarOpen(prev => ({ ...prev, open: true, message: t('schedule.snackbar.delete.error.unique'), type: Types.ERROR }))
      }

      if (modalDelete.type == TypeDeleteSchedule.SERIE) {
        setSnackbarOpen(prev => ({ ...prev, open: true, message: t('schedule.snackbar.delete.error.serie'), type: Types.ERROR }))
      }

      if (modalDelete.type == TypeDeleteSchedule.MASIVE) {
        setSnackbarOpen(prev => ({ ...prev, open: true, message: t('schedule.snackbar.delete.error.masive', { count: selectedIds.length }), type: Types.ERROR }))
      }
    }

    setIsLoadingDelete(false)
    setModalDelete(prev => ({ ...prev, open: false }))
  }

  const handleDisabled = () => {
    const questionnaireIsOpen = !!data?.openQuestionnaire
    if ([2, 3].includes(steps ?? 0) || (openModal.id && (steps ?? 0) > 0)) {
      let arrayAgentsChecket = Object.values(data?.stores ?? {})
      let agentAllChecketFalse = arrayAgentsChecket?.some((item: any) => item.length === 0)

      ////if ([Roles.AGENT, Roles.AUDIT].includes(getUserRole() as Roles)) agentAllChecketFalse = false

      return !!questionnaireIsOpen && !agentAllChecketFalse ? false : disabled(data, agentAllChecketFalse) || Object.values(allErrors).some((item: any) => item)
    }
    else if (steps === 1 || ((openModal.id || isPartner) && steps === 0)) return selected.questionnaire?.length <= 0
    else if (steps === 0) return selected.stores?.length <= 0
  }

  const handleUploadFile: onChange = ({ target }) => {
    const { value } = target

    if (filesValidate.correctTypeFile.includes(value?.type)) {
      setDataUpload(value)
      setAllErrors({
        ...allErrors,
        dataUpload: null,
      })
    } else {
      setDataUpload(undefined)
      setAllErrors({
        ...allErrors,
        dataUpload: t('general.validations.wrongFile'),
      })
    }
  }

  const handleUpload = async () => {
    setErrorMassiveLoad(null)
    if (dataUpload) {
      setLoadUpload(true)
      const formData = new FormData()
      formData.append('file', dataUpload as Blob)
      const response = await ScheduleService(httpFetch).loadSchedule(formData)

      const responseJson = await response.json()
      const { code } = responseJson

      if (response?.status === 200) {
        if (code === '01') {
          setAllErrors({
            ...allErrors,
            dataUpload: t('general.invalidateTemplate'),
          })
        }
        if (code === ErrorsCode.AllUsersHavePermissions) {
          setOpenModalCSV(false)
          setDataUpload(undefined)
          setOpenSnackbar({
            open: true,
            type: Types.SUCCESS,
            message: t(`general.successBatch`),
          })
        }
        if (code === '03') {
          setDataUpload(undefined)
          setErrorMassiveLoad(responseJson)
        }
        if (code === '04') {
          setAllErrors({
            ...allErrors,
            dataUpload: t('general.fileEmptyError'),
          })
        }
      } else if (response?.status === 400) {
        if (code === '01') {
          setAllErrors({
            ...allErrors,
            dataUpload: t('general.invalidateTemplate'),
          })
        }
        if (code === '04') {
          setAllErrors({
            ...allErrors,
            dataUpload: t('general.fileEmptyError'),
          })
        }
      }
      setLoadUpload(false)
    }
  }

  const downloadLocale = (viewDocument?: string) => {
    window.open(viewDocument ?? `${process.env.REACT_APP_TEMPLATE_XLSX}?d=${Date.now()}`, 'blank')
  }

  const handleMenu = (item: ItemMenu) => {
    switch (item?.value) {
      case 2:
        handleCreate()
        break
      case 1:
        setOpenModalCSV(true)
        break
      default:
        break
    }
  }

  const handleCloseModalUpload = () => {
    setOpenModalCSV(false)
    setDataUpload(undefined)
    setAllErrors({
      ...allErrors,
      dataUpload: null,
    })
  }

  /*======RESEND REPORT========
    ==========START============
  */
  const closeResendModal = () => {
    setResendReport(prev => ({ ...prev, open: false, values: {}, close: () => { }, send: () => { } }))
    setErrorsResend([])
  }

  const submitResendReport = ({ id, data, questionnaireOption, type }: SubmitResendReport) => {
    setDisabledModal((prev) => ({
      ...prev,
      resendButtonLoading: true,
    }))

    const emails = data?.externalEmails
      ?.split(',')
      ?.filter((item: string) => !!item)

    let body: ObjectGeneric = {
      user_assign: !!data?.user_assign,
      users_supervisors: !!data?.users_supervisors,
      users_store: !!data?.users_store,
      user_manage_store: !!data?.user_manage_store,
      email_store: !!data?.email_store,
      type: type ?? resendReportTypes.report,
      user_groups: (data?.selectGroup ?? []).map((item:{label:string, value:number})=>item.value)
    }

    if (!!emails?.length) body['external_emails'] = emails

    const localeId = questionnaireOption?.id ?? id
    const endpointResend = questionnaireOption?.id ? actionPlanFetch.sendReportQuestionnaire : actionPlanFetch.sendReport

    endpointResend(localeId, body)
      .then((response) => {
        if (!response?.errors) {
          closeResendModal()
          setOpenSnackbar({
            open: true,
            type: Types.SUCCESS,
            message: t('general.reportSuccess'),
          })
        } else {
          if (['00', '01', '02'].includes(response.code)) {
            if (response.code == '00') {
              closeResendModal()
              setOpenSnackbar({
                open: true,
                type: Types.SUCCESS,
                message: t('general.reportSuccess'),
              })
            } else if (response.code == '01') {
              let listErrors = []

              if (response.data?.userAssign) { listErrors.push(t(`reportFolio.modal.sendReport.userWhoResponded`)) }
              if (response.data?.usersSupervisors) { listErrors.push(t(`reportFolio.modal.sendReport.userSupervisor`)) }
              if (response.data?.usersStore) { listErrors.push(t(`reportFolio.modal.sendReport.userStore`)) }
              if (response.data?.userManageStore) { listErrors.push(t(`reportFolio.modal.sendReport.agentStore`)) }
              if (response.data?.emailStore) { listErrors.push(t(`reportFolio.modal.sendReport.emailStore`)) }
              if (!!response.data?.externalEmails?.length) { listErrors.push(`${t(`reportFolio.modal.sendReport.externalEmails`)}: ${response.data?.externalEmails?.join(', ')}`) }

              setErrorsResend(listErrors)
            } else if (response.code == '02') {
              setOpenSnackbar({
                open: true,
                type: Types.ERROR,
                message: t('general.reportError'),
              })
            }
          } else if (!!response.errors) {
            setOpenSnackbar({
              open: true,
              type: Types.ERROR,
              message: handleAllErrors(response?.errors[0].code, t, t('general.reportError')),
            })
          }
        }
      })
      .finally(() => {
        setDisabledModal((prev) => ({
          ...prev,
          resendButton: true,
          resendButtonLoading: false,
        }))
      })
  }

  const handleSendReportData: onChange = ({ target }) => {
    const { name, value } = target
    setErrorsResend([])
    const body: ObjectGeneric = {
      ...structuredClone(resendReport.values),
      [name]: value,
    }

    /* START EMAIL VALIDATE */
    const emailValue = name === 'externalEmails' ? value : body?.externalEmails
    let emailIsSeparate = false
    emailIsSeparate = !(!emailValue || isEmailSeparateToCome(emailValue))
    /* END EMAIL VALIDATE */


    setDisabledModal((prev) => ({
      ...prev,
      resendButton:
        !Object.values(body ?? {})?.some((item) => !!item) || emailIsSeparate,
    }))

    setResendReport((prev) => ({
      ...prev,
      values: {
        ...prev?.values ?? {},
        [name]:
          name === 'externalEmails'
            ? value?.replace(/(\r\n|\n|\r|\s)/gm, '')
            : value,
        ...(name === 'user_group' && value === false
          ? { selectGroup: [] }
          : {}),
      }
    }))
  }

  /*======RESEND REPORT========
    ==========END============
  */

  const goBack = (data?: { doNotCleanTheFilters?: boolean }) => {
    setSteps(null)
    setData(initialData)
    setAllErrors({})
    setSelected({ stores: [], questionnaire: [] })
    setDetailAssigned({})
    handleCloseModal(true)
    setOpenPreview(false)
    setOpenModalExit(false)
    setOpenModal((prev) => ({
      ...prev,
      id: undefined,
    }))
    if (!data?.doNotCleanTheFilters) {
      setAllErrors((prev) => ({
        ...prev,
        from: null,
        to: null,
      }))
    }
    getDetail({
      query: returnQuery(query, formData).split('&')
        .filter(item => Boolean(item) && !(item.includes('programmed'))).join('&'),
      goBack: true,
    })
  }

  const getMatchData = (payload: ObjectGeneric) => {
    setDataList(payload.dataList)
    setIsSendingAll(!!payload.isSendingAll)
  }

  const downloadCustomePdf = () => {
    getDetailInform({ query: returnQueryWithPagination({ filter: filterString.split('&').filter(item => Boolean(item) && !(item.includes('programmed'))).join('&'), sort: query.sort }, formData), type: 'pdf' })
  }

  const downloadCustomeWord = () => {
    getDetailInform({ query: returnQueryWithPagination({ filter: filterString.split('&').filter(item => Boolean(item) && !(item.includes('programmed'))).join('&'), sort: query.sort }, formData), type: 'word' })
  }

  const downloadCustomeExcel = () => {
    getDetailInform({ query: returnQueryWithPagination({ filter: filterString.split('&').filter(item => Boolean(item) && !(item.includes('programmed'))).join('&'), sort: query.sort }, formData), type: 'excel' })
  }

  useEffect(() => {
    if (uuid && (!steps && steps !== 0)) {
      const interval = setInterval(() => {
        getDetailInform({ query: returnQueryWithPagination({ filter: filterString.split('&').filter(item => Boolean(item) && !(item.includes('programmed'))).join('&'), sort: query.sort }, formData) });
      }, 30000);
      return () => clearInterval(interval);
    }
  }, [uuid, steps])

  useEffect(() => {
    if (!flag) getAllData()
  }, [getAllData, flag, query.all])
  useEffect(() => {
    if (flag) {
      executeFunction({
        execute: () => {
          getDetail({
            query: returnQuery(query, formData).split('&')
              .filter(item => Boolean(item) && !(item.includes('programmed'))).join('&'),
            goBack: true,
          })
          setSelectedIds([]);
          setNotFolioSelected([]);
        }
      })
    }
    //eslint-disable-next-line
  }, [query.all])

  useEffect(() => {
    getUserGroup()
  }, [])

  return (
    <Box sx={styles.container}>
      <SnackSimple close={handleCloseSnackbar} open={openSnackbar.open} type={openSnackbar.type} message={openSnackbar.message} />

      {/* <SnackSimple close={closeOpenSnakbar} open={snackbarDownloadModal.open} type={snackbarDownloadModal.type} message={snackbarDownloadModal.message} /> */}

      <SnackSimple open={snackbarOpen.open} close={() => { setSnackbarOpen(prev => ({ ...prev, open: false })) }} message={snackbarOpen.message} type={snackbarOpen.type} />

      <DetailModal
        agent={data.agent}
        description={data.description}
        from={data.from}
        to={data.to}
        goBack={goBack}
        open={openPreview}
        optionMenu={optionMenu}
        questionnaireList={detailAssigned?.questionnaire?.list}
        reportUrl={detail.reportUrl}
        storeList={detailAssigned?.stores?.list}
        supervisor={data.supervisor}
        title={data.title}
        questionnairesUrls={detailAssigned?.questionnairesUrls}
        storeSize={detailAssigned?.stores?.size}
      />
      <BaseModal sx={styles.resendModal as SxProps} open={resendReport?.open}>
        <Box style={styles.resendReportContainer as any}>
          <IconButton
            sx={styles.close}
            onClick={() => {
              resendReport.close()
            }}
          >
            {icons('simple-close')}
          </IconButton>

          <Typography sx={styles.titleSend}>{resendReport.title}</Typography>

          <DinamicForm input={Object.values(resendReportForm)} values={resendReport.values} onChange={handleSendReportData} spacing={{ row: 0 }} />

          {resendReport.values.user_group &&
            <FilterSelect
              name={'selectGroup'}
              label={'Grupo'}
              onChange={handleSendReportData}
              items={userGroup}
              selected={resendReport.values.selectGroup}
            />
          }

          <Typography sx={styles.titleSend}>{t('reportFolio.modal.sendReport.emails')}</Typography>

          <DinamicForm input={Object.values(resendReportFormEmails)} values={resendReport.values} onChange={handleSendReportData} />
          {
            !!errorsResend?.length && (
              <Box sx={styles.containerErrorsResend}>
                <Typography>{t(`reportFolio.modal.sendReport.01`)}:</Typography>

                <ul>
                  {
                    errorsResend?.map((item, index) => (
                      <li><Typography>* {item}</Typography></li>
                    ))
                  }
                </ul>
              </Box>
            )
          }
          <Box sx={styles.resendButton}>
            <LoadingButton
              loading={!!disabledModal.resendButtonLoading}
              disabled={!!disabledModal?.resendButton}
              type="submit"
              onClick={() => {
                resendReport.send({ data: resendReport.values })
              }}
              sx={styles.button}
              variant="contained"
            >
              {t('reportFolio.buttons.resend')}
            </LoadingButton>
          </Box>
        </Box>
      </BaseModal>

      <SimpleModal
        sx={styles.simpleModal}
        open={openModalCSV}
        isLoading={loadUpload}
        title={!loadUpload && !errorMassiveLoad ? t('general.loadMassiveScheduled') : undefined}
        loadingButton
        disableButton={!dataUpload ? true : false}
        close={() => {
          handleCloseModalUpload()
        }}
        children={
          <Box sx={styles.uploadFile}>
            {!loadUpload && !errorMassiveLoad && (
              <>
                <Box sx={styles.wFull}>
                  <Typography sx={styles.link}>
                    <span className="circle">&#x2B24;</span>Se proporciona la plantilla para la carga de la agenda: <br />
                    <span
                      onClick={() => {
                        downloadLocale()
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      Descargar plantilla
                    </span>
                  </Typography>
                </Box>

                <Box sx={styles.file}>
                  <SimpleFile
                    errors={allErrors}
                    notImage
                    onChange={handleUploadFile}
                    item={{
                      label: 'general.tags.loadCsv',
                      translate: true,
                      name: 'dataUpload',
                      value: null,
                      validate: {
                        required: true,
                      },
                      rest: {
                        accept: filesValidate.accept,
                        simpleFile: true,
                      },
                    }}
                    values={dataUpload}
                    customeIcon="add"
                  />
                </Box>
              </>
            )}

            {loadUpload && (
              <>
                <Box sx={styles.wFull}>
                  <Typography variant="body1" sx={styles.infoTitle}>
                    Comprobación de <br /> Carga Masiva de Agenda
                  </Typography>
                </Box>
                <Box sx={styles.wFull}>
                  <Typography sx={styles.infoText}>Estamos haciendo la carga masiva, por favor espere. Este proceso puede tomar unos minutos</Typography>
                </Box>

                <Loader />
              </>
            )}

            {!loadUpload && errorMassiveLoad && (
              <>
                <Box sx={styles.wFull}>
                  <Typography variant="body1" sx={[styles.infoTitle, styles.left]}>
                    Resultados de <br /> Carga Masiva de Agendas
                  </Typography>
                </Box>
                <Box sx={styles.wFull}>
                  <Typography sx={[styles.infoText, styles.left]}>A continuación se detallan los resultados de la carga masiva del archivo de agendas enviado.</Typography>
                </Box>

                <Box sx={styles.errorInfo}>
                  <Box sx={styles.green}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: 20 }}>{errorMassiveLoad?.itemsCorrect}</Typography>
                    <Typography sx={{ fontSize: 12 }}>Agendas cargadas</Typography>
                  </Box>
                  <Box sx={styles.red}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: 20 }}>{errorMassiveLoad?.itemsIncorrect}</Typography>
                    <Typography sx={{ fontSize: 12 }}>Registros con error</Typography>
                  </Box>
                </Box>

                <Paper elevation={3} sx={{ p: 2, mt: 2 }}>
                  <Typography sx={{ fontSize: 12, color: '#707070', fontWeight: 600 }}>RESOLUCIÓN DE CONFLICTOS</Typography>

                  <Box
                    onClick={() => {
                      const link = document.createElement('a')
                      link.href = errorMassiveLoad.urlError
                      link.click()
                    }}
                    sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', padding: '5px 0 20px 0', cursor: 'pointer' }}
                  >
                    <FileDownload sx={styles.downloadIcon} />
                    <Typography sx={styles.download}>Descargar registros no cargados</Typography>
                  </Box>

                  <Box sx={styles.file}>
                    <SimpleFile
                      errors={allErrors}
                      notImage
                      onChange={handleUploadFile}
                      item={{
                        label: 'general.tags.loadCsv',
                        translate: true,
                        name: 'dataUpload',
                        value: null,
                        validate: {
                          required: true,
                        },
                        rest: {
                          accept: filesValidate.accept,
                          simpleFile: true,
                        },
                      }}
                      values={dataUpload}
                      customeIcon="add"
                    />

                    <Button
                      onClick={() => {
                        handleUpload()
                      }}
                      variant="contained"
                      disabled={!dataUpload ? true : false}
                    >
                      REINTENTAR
                    </Button>
                  </Box>
                </Paper>
              </>
            )}
          </Box>
        }
        buttonText={t('general.importData')}
        cancelText={t('general.cancel')}
        color={colors}
        back={() => {
          handleCloseModalUpload()
        }}
        next={handleUpload}
        removeButtons={loadUpload || errorMassiveLoad}
      />

      <SimpleModal
        open={openModalExit}
        close={() => {
          setOpenModalExit(false)
          setIsLoadingConfirm(false)
        }}
        title={t('general.exit')}
        description={t('general.lostChange')}
        buttonText={t('general.confirm')}
        cancelText={t('general.cancel')}
        color={colors}
        back={() => {
          setOpenModalExit(false)
        }}
        next={goBack}
      />

      <SimpleModal
        open={openModalError}
        close={() => {//se comentó´pues al solo cargar unos se recargaba la pagina
          /* if (errorMsg.code == ErrorsCode.SomeOneUserNotHavePermissions) {
            getDetail({ reloadItems: true })
          } else { */
          setOpenModalError(false)
          /* } */
          setIsLoadingConfirm(false)
        }}
        title={errorMsg.title}
        errorMsg={errorMsg.message}
        buttonText={t('general.confirm')}
        cancelText={t('general.cancel')}
        color={colors}
        back={
          errorMsg.code !== ErrorsCode.SomeOneUserNotHavePermissions
            ? () => {
                /* errorMsg.code != '01' &&  */ setOpenModalError(false)
              // errorMsg.code == '01' && getDetail({ reloadItems: true })
            }
            : undefined
        }
        next={() => {
          /* if (errorMsg.code == ErrorsCode.SomeOneUserNotHavePermissions) {
            getDetail({ reloadItems: true })
          } else { */
          setOpenModalError(false)
          /*  } */
        }}
      />

      <SimpleModal
        open={openModal.open}
        close={handleCloseModal}
        title={openModal.title}
        description={openModal.description}
        buttonText={t('general.confirm')}
        cancelText={t('general.cancel')}
        color={colors}
        back={handleCloseModal}
        loadingButton
        isLoading={isLoadingConfirm}
        next={existId && !openModal.submit ? handleCloseScheduled : handleConfirm}
      />
      <SimpleModal
        open={!!modalDelete.open}
        next={handleDeleteSchedules}
        back={closeModalDelete}
        close={closeModalDelete}
        description={modalDelete.description}
        buttonText={t('general.confirm')}
        cancelText={t('general.cancel')}
        title={modalDelete.title}
        loadingButton
        isLoading={isLoadingDelete}
      //isLoading={isLoadingConfirm}
      /* sx={{ width: '470px' }}
      children={modal.children} */
      />
      {!steps && steps !== 0 && (
        <Box sx={styles.containerTable}>
          <BreadCrumb
            notAddPath
          />
          {/* HEADER */}
          <Box sx={[styles.header, styles.actions]}>
            <Box sx={styles.headerTitle}>
              <Typography variant='title_grey_big'>{t('schedule.filter.title')}</Typography>
            </Box>

            <Box sx={styles.flex}>
              <LinearProgressDownload show={downloadLoading} text={t(`schedule.snackbar.generateScheduleDownload_${typeDownload}`)} />
              <ModelDownloadButtons styleType csv={downloadCustomeExcel} pdf={downloadCustomePdf} word={downloadCustomeWord} disableCSV={downloadLoading} disablePDF={downloadLoading} disableWORD={downloadLoading} />

              <Button /* sx={styles.deleteButon} */ variant="outlined" color="primary" onClick={handleOpenModalDelete}>
                {t('reportFolio.newDashboard.btnsHeader.delete')}
              </Button>

              <Tooltip title={t('ToolTips.create')}>
                <IconButton className="add" onClick={handleClick}>
                  {icons('add')}
                </IconButton>
              </Tooltip>


              {
                !canAccess([Roles.AUDIT]) && (
                  <Tooltip title={t('ToolTips.import')}>
                    <IconButton
                      className="openModal"
                      onClick={() => {
                        setOpenModalCSV(true)
                        setErrorMassiveLoad(false)
                        setLoadUpload(false)
                      }}
                    >
                      {icons('list')}
                    </IconButton>
                  </Tooltip>
                )
              }

              {!!counter &&
                <Tooltip title={t('ToolTips.clearFilters')}>
                  <IconButton
                    sx={(styles.clean, (counter || 0) > 0 ? null : styles.hide)}
                    onClick={() => {
                      handleCheanFilter()
                    }}
                  >
                    {icons('clean')}
                  </IconButton>
                </Tooltip>
              }

              <BaseMenu anchorEl={anchorEl} setAnchorEl={setAnchorEl} menuItems={menu} click={handleMenu} />
            </Box>
          </Box>

          {/* FLOATS */}
          <FiltersDrawer cleanFilter={handleCheanFilter} count={counter} right={0} top={50}>
            <Box sx={styles.section}>
              <DinamicForm errors={errors} input={Object.values(input)} values={filterData} onChange={onChange} filter={true} />
            </Box>
          </FiltersDrawer>

          <BaseMenu
            sx={[styles.baseMenu, detail.positionMenu]}
            anchorEl={detail.anchor}
            setAnchorEl={closeMenu}
            menuItems={detail.menu}
            click={(item) => {
              optionMenu({ item: item as Item })
            }}
          />

          {/* TABLE */}
          {!loadingTable ? (
            <CustomTable
              order={
                query?.sort && {
                  count: query?.sort?.count,
                  key: query?.sort?.field,
                  order: query?.sort?.sort,
                }
              }
              sortable={(field, sort, count) => {
                sortTable(field && sort ? { field: field, sort: sort, count } : undefined)
              }}
              serverSidePagination={{ page: paginationModel.page + 1, size: paginationModel.pageSize, totalPages }}
              handleChange={(page: number, pageSize: number) => {
                handlePagination({ page, pageSize })
              }}
              column={column}
              row={table.row}
              color={colors}
              selected={-1}
            />
          ) : (
            <Loader />
          )}
          {/* </Grid> */}
        </Box>
      )
      }
      {
        !(!steps && steps !== 0) && (
          <AgentSteps
            isParner={isPartner}
            ref={(element) => { ref.addRef({ element, name: 'step' }) }}
            goBack={goBackToList}
            handleSteps={handleSteps}
            color={colors}
            stepsArray={(!openModal.id && !isPartner) ? stepsArray : stepsArrayEdit}
            activeStep={steps}
            steps={steps}
            disabled={handleDisabled()}
            id={openModal.id}
            getMatchData={getMatchData}
            items={items}
            step1={{
              steps: steps,
              filterRow,
              initialFilterValues,
              id: openModal.id,
              t,
              table: tableStores,
              isLoading,
              header: {
                title: t('schedule.filter.filterStore.title'),
                search: t('schedule.filter.filterStore.search'),
              },
              handleInformation: (e) => {
                setSelected({
                  ...selected,
                  stores: e.checks,
                })
              },
              defaultChecks: selected.stores,
            }}
            step2={{
              filterRow,
              initialFilterValues,
              id: openModal.id,
              t,
              header: {
                title: t('schedule.filter.filterQuestionnaire.title'),
                search: t('schedule.filter.filterQuestionnaire.search'),
              },
              table: tableQuestionnarie,
              isLoading,
              handleInformation: (e) => {
                setSelected({
                  ...selected,
                  questionnaire: e.checks,
                })
              },
              defaultChecks: selected.questionnaire,
            }}
            step3={{
              send: data.send,
              isLoading,
              userSuccess: userSuccess,
              errorQuestionnairesDuplicated,
              errorUsersQuestionnaries,
              id: openModal.id,
              errors: allErrors,
              listMatched,
              deleteItem: handleDeleteDetail,
              onChange: crudChange,
              checkedDelete: deleteChekedTrue,
              checkedAdd: deleteCheckedFalse,
              input: Object.values(inputModel),
              detail: detailAssigned,
              availability: {
                from: data.from ?? null,
                to: data.to ?? null,
                frequency: data.frequency ?? null,
                every: data.every ?? null,
                title: data.title ?? null,
                description: data.description ?? null,
                notified: data.notified ?? false,
                stores: data.stores,
                openQuestionnaire: !!data.openQuestionnaire,
              },
            }}
          />
        )}
    </Box>
  )
}

export default Calendar